import React from "react";
import produce from "immer";

import InputContainer from "./InputContainer";
import ShowTodo from "./ShowTodo";
import Footer from "./Footer";

import { saveTodo, getTodo } from "./utils";

export default class TodoApp extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      inputValue: "",
      todoList: []
    };
  }

  componentDidMount() {
    const retrievedTodo = getTodo() || [];
    if (retrievedTodo.length > 0) {
      this.setState({ todoList: retrievedTodo });
    }
  }

  handleInputChange = e => {
    const { target: { value = "" } = {} } = e;
    this.setState({ inputValue: value });
  };

  onSubmit = () => {
    const { inputValue } = this.state;
    this.setState(
      produce(draft => {
        draft.todoList.unshift({
          desc: inputValue,
          completed: false,
          editing: false
        });
        draft.inputValue = "";
      })
    );
  };

  onTodoClick = index => () => {
    this.setState(
      produce(draft => {
        draft.todoList[index].editing = !this.state.todoList[index].editing;
      })
    );
  };

  onEdit = index => e => {
    const value = e.target.value;
    this.setState(
      produce(draft => {
        draft.todoList[index].desc = value;
      })
    );
  };

  onComplete = index => e => {
    const checked = e.target.checked;
    this.setState(
      produce(draft => {
        draft.todoList[index].completed = checked;
      })
    );
  };

  onClear = () => {
    const { todoList } = this.state;
    const filteredTodo = todoList.filter((todo = {}) => !todo.completed);
    this.setState({ todoList: filteredTodo });
  };

  onGroupTodo = () => {
    const { todoList } = this.state;
    if (todoList.length === 1) {
      return;
    }
    this.setState(
      produce(draft => {
        draft.todoList.sort((todo = {}, todoNext = {}) => {
          return Number(todo.completed) - Number(todoNext.completed);
        });
      })
    );
  };

  componentDidUpdate() {
    const { todoList } = this.state;
    saveTodo(todoList);
  }

  render() {
    const { inputValue, todoList } = this.state;
    return (
      <React.Fragment>
        <InputContainer
          value={inputValue}
          handleInputChange={this.handleInputChange}
          onSubmit={this.onSubmit}
        />

        <ShowTodo
          todoList={todoList}
          onTodoClick={this.onTodoClick}
          onEdit={this.onEdit}
          onComplete={this.onComplete}
        />
        {!!todoList.length && (
          <Footer onClear={this.onClear} onGroup={this.onGroupTodo} />
        )}
      </React.Fragment>
    );
  }
}
